import { useOrgContext } from '@/org/contexts/OrgContext'
import { CircleFragment } from '@gql'
import { useMemo } from 'react'
import useMyRoles from './useMyRoles'

// Circles that own the current member's roles ("my circles"): the direct parent
// circle of each of the member's roles, deduplicated. Used to scope role/circle
// pickers to the member's own circles (ORG-02). E.g. a role "Outils numériques"
// under "Accompagnements" yields "Accompagnements".
export default function useMyCircles(): CircleFragment[] {
  const { orgData } = useOrgContext()
  const myRoles = useMyRoles()

  return useMemo(() => {
    if (!orgData) return []
    const parents = new Map<string, CircleFragment>()
    for (const role of myRoles) {
      const parent = role.parentId
        ? orgData.getCircle(role.parentId)
        : undefined
      if (parent) parents.set(parent.id, parent)
    }
    return [...parents.values()]
  }, [orgData, myRoles])
}
